module.exports = __webpack_public_path__ + "static/Audit-2-50f65c508449c8276fbd7580a92126d7.svg";